import { StyleSheet } from 'aphrodite';
import { background, brandPrimaryText, inputBorderColor } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	callForwardingInput: {
		borderRadius: 8,
		backgroundColor: background,
		borderColor: inputBorderColor,
		borderStyle: 'solid',
		borderWidth: '1px',
		height: 40,
		width: 270,
	},
	contactSupport: {
		color: brandPrimaryText,
		paddingLeft: 40,
		textDecoration: 'none',
	},
	container: {},
	enableForwardingContainer: {
		alignItems: 'center',
		display: 'flex',
	},
	fieldErrorContainer: {
		marginLeft: 20,
	},
	textSignatureDisclosureInput: {
		height: 124,
		padding: 14,
		paddingTop: 10,
		maxHeight: '50vh',
		minHeight: 124,
		maxWidth: 600,
		resize: 'vertical',
	},
	marginBottom: {
		marginBottom: 10,
	},
	sections: {
		fontSize: 14,
		...CssSelectors.allChildren(
			{
				marginTop: 28,
			},
			':not(:first-child)'
		),
	},
});
